(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-reset-play-atoms.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-reset-play-atoms.js');
"use strict";

const {
  useSetAtom
} = jotai;
const {
  atomWithSvSStorage
} = svs.lyckoplatsen.shared_utils;
const {
  getDefaultLocationName
} = svs.tur.lyckoplatsen.utils;
const useResetPlayAtoms = () => {
  const {
    defaultPlayValues
  } = svs.lyckoplatsen.components.page_play.jotai;
  const {
    disableCenterMapButtonAtom,
    locationConfirmedAtom,
    mapLocationAtom,
    pinLocationAtom,
    pinLocationTypeAtom,
    shouldShowPinAtom
  } = svs.lyckoplatsen.components.page_play.jotai.atoms;
  const {
    charityAtom
  } = svs.lyckoplatsen.shared_charity.jotai.atoms;
  const lyckoplatsenNameAtom = atomWithSvSStorage('lyckoplatsenName');
  const setPinLocation = useSetAtom(pinLocationAtom);
  const setPinLocationType = useSetAtom(pinLocationTypeAtom);
  const setMapLocation = useSetAtom(mapLocationAtom);
  const setDisableCenterMapButton = useSetAtom(disableCenterMapButtonAtom);
  const setLocationConfirmed = useSetAtom(locationConfirmedAtom);
  const setShouldShowPinAtom = useSetAtom(shouldShowPinAtom);
  const setLyckoplatsenName = useSetAtom(lyckoplatsenNameAtom);
  const setCharityAtom = useSetAtom(charityAtom);
  return () => {
    setPinLocation(defaultPlayValues.pinLocationAtom);
    setPinLocationType(defaultPlayValues.pinLocationTypeAtom);
    setMapLocation(defaultPlayValues.mapLocationAtom);
    setDisableCenterMapButton(defaultPlayValues.showDisableMapButtonAtom);
    setLocationConfirmed(defaultPlayValues.locationConfirmedAtom);
    setShouldShowPinAtom(defaultPlayValues.shouldShowPinAtom);
    setLyckoplatsenName(getDefaultLocationName());
    setCharityAtom(null);
  };
};
setGlobal('svs.lyckoplatsen.components.page_play.react.hooks.useResetPlayAtoms', useResetPlayAtoms);

 })(window);